import * as normalize from 'utils/normalize';
import getBusinessName from 'utils/print/getBusinessName';
import getBusinessAddress from 'utils/print/getBusinessAddress';
import getCurrentDate from 'utils/print/getCurrentDate';
import getSignature from 'utils/print/getSignature';
import getInquiringProviderUserName from 'utils/print/getInquiringProviderUserName';
import getPaymentValue from 'utils/print/getPaymentValue';
import getBusinessEmail from 'utils/print/getBusinessEmail';

const SAASAgreement = {
  ID: 30,
  Name: 'Advance Beneficiary Notice',
  Type: 'Contract',
  Format: 'letter',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/SAAS-Agreement/1.js',
      texts: [
        {
          name: 'DME Name',
          getText: props => 'DME FOR DME LLC',
          x: 63,
          y: 41,
          width: 77,
          fontSize: 11,
          lineHeight: 1.1,
        },
        {
          name: 'DME Address',
          getText: props => '4809 AVENUE N SUITE 320 BROOKLYN NY 11234',
          x: 44,
          y: 47,
          width: 77,
          fontSize: 11,
          lineHeight: 1.1,
        },
      ],
      fields: [
        {
          name: 'Current Date',
          type: 'text',
          getValue: getCurrentDate,
          normalize: normalize.date,
          x: 147,
          y: 34,
          width: 21,
        },
        {
          name: 'Business Name 1',
          type: 'text',
          getValue: getBusinessName,
          x: 25,
          y: 53,
          width: 90,
        },
        
        {
          name: 'Business Address',
          type: 'text',
          getValue: getBusinessAddress,
          x: 43,
          y: 59.5,
          width: 119,
        },
      ],
    },
    {
      ID: 2,
      imageUrl: 'assets/documents/SAAS-Agreement/2.js',
    },
    {
      ID: 3,
      imageUrl: 'assets/documents/SAAS-Agreement/3.js',
    },
    {
      ID: 4,
      imageUrl: 'assets/documents/SAAS-Agreement/4.js',
    },
    {
      ID: 5,
      imageUrl: 'assets/documents/SAAS-Agreement/5.js',
    },
    {
      ID: 6,
      imageUrl: 'assets/documents/SAAS-Agreement/6.js',
    },
    {
      ID: 7,
      imageUrl: 'assets/documents/SAAS-Agreement/7.js',
    },
    {
      ID: 8,
      imageUrl: 'assets/documents/SAAS-Agreement/8.js',    
    },
    {
      ID: 9,
      imageUrl: 'assets/documents/SAAS-Agreement/9.js',
       texts: [
        {
          name: 'DME Date',
          getText: getCurrentDate,
          x: 185,
          y: 94,
          width: 21,
          fontSize: 11,
          lineHeight: 1.1,
        },
        {
          name: 'DME Name',
          getText: props => 'DME FOR DME LLC',
          x: 140,
          y: 99,
          width: 77,
          fontSize: 11,
          lineHeight: 1.1,
        },
        {
          name: 'DME Signer Name',
          getText: props => 'Zaur Yusufov',
          x: 140,
          y: 107,
          width: 77,
          fontSize: 11,
          lineHeight: 1.1,
        },
      ],
      fields: [
        {
          name: 'Business Signature',
          type: 'signature',
          getValue: getSignature,
          x: 140,
          y: 154,
          width: 50,
          height: 10,
        },   
        {
          name: 'Signature Date',
          type: 'text',
          getValue: getCurrentDate,
          normalize: normalize.date,
          x: 185,
          y: 165,
          width: 21,
        },
        {
          name: 'Business Name',
          type: 'text',
          getValue: getBusinessName,
          x: 139,
          y: 168.5,
          width: 50,
          height: 10,
          multiline: true,
        },
        {
          name: 'Signer Name',
          type: 'text',
          getValue: getInquiringProviderUserName,
          x: 139,
          y: 179.5,
          width: 50,
          height: 10,
          multiline: true,
        },
        {
          name: 'Signer Title',
          type: 'text',
          x: 139,
          y: 191,
          width: 50,
          height: 10,
          multiline: true,
        },
      ],
    },
    {
      ID: 10,
      imageUrl: 'assets/documents/SAAS-Agreement/10.js',
    },
    {
      ID: 11,
      imageUrl: 'assets/documents/SAAS-Agreement/11.js',
    },
    {
      ID: 12,
      imageUrl: 'assets/documents/SAAS-Agreement/12.js',
    },
    {
      ID: 13,
      imageUrl: 'assets/documents/SAAS-Agreement/13.js',
    },
    {
      ID: 14,
      imageUrl: 'assets/documents/SAAS-Agreement/14.js',
    },
    {
      ID: 15,
      imageUrl: 'assets/documents/SAAS-Agreement/15.js',
    },
    {
      ID: 16,
      imageUrl: 'assets/documents/SAAS-Agreement/16.js',
    },
    {
      ID: 17,
      imageUrl: 'assets/documents/SAAS-Agreement/17.js',
      texts: [
        {
          name: 'DME Date 0',
          getText: getCurrentDate,
          x: 145,
          y: 44,
          width: 21,
          fontSize: 11,
          lineHeight: 1.1,
        },
        {
          name: 'DME Date 1',
          getText: props => 'December 1',
          x: 120,
          y: 56,
          width: 21,
          fontSize: 11,
          lineHeight: 1.1,
        },
        {
          name: 'DME Date 2',
          getText: props => '2025',
          x: 145,
          y: 56,
          width: 21,
          fontSize: 11,
          lineHeight: 1.1,
        },
        {
          name: 'DME Name',
          getText: props => 'DME FOR DME LLC',
          x: 39,
          y: 62,
          width: 77,
          fontSize: 11,
          lineHeight: 1.1,
        },
        {
          name: 'Order Value',
          getText: getPaymentValue,
          x: 50,
          y: 152,
          width: 77,
          fontSize: 11,
          lineHeight: 1.1,
        },
      ],
      fields: [
        {
          name: 'Business Name 1',
          type: 'text',
          getValue: getBusinessName,
          x: 107,
          y: 62,
          width: 55,
        },
        {
          name: 'Billing Business Name',
          type: 'text',
          getValue: getBusinessName,
          x: 88,
          y: 224,
          width: 70,
        },
        {
          name: 'Billing Name',
          type: 'text',
          getValue: getInquiringProviderUserName,
          x: 88,
          y: 227,
          width: 70,
          height: 10,
          multiline: true,
        },
        {
          name: 'Billing Email',
          type: 'text',
          getValue: getBusinessEmail,
          x: 88,
          y: 239,
          width: 70,
          height: 10,
          multiline: true,
        },
      ],
    },
    {
      ID: 18,
      imageUrl: 'assets/documents/SAAS-Agreement/18.js',
      fields: [
        {
          name: 'Billing Email',
          type: 'text',
          getValue: getBusinessAddress,
          x: 88,
          y: 25,
          width: 70,
          height: 10,
          multiline: true,
        },
      ],
    },
  ],
};

export default SAASAgreement;



// WEBPACK FOOTER //
// ./src/config/documents/SAAS-Agreement.js